import { DecoratorNode } from "lexical";
import { MentionComponent } from "./MentionComponent";

export class MentionNode extends DecoratorNode {
  constructor(id = "", name = "", key) {
    super(key);
    this.__id = id;
    this.__name = name;
  }

  static getType() {
    return "mention";
  }

  static clone(node) {
    return new MentionNode(node.__id, node.__name, node.__key);
  }

  exportJSON() {
    return {
      type: "mention",
      version: 1,
      id: this.__id,
      name: this.__name,
    };
  }

  static importJSON(serializedNode) {
    const { id, name } = serializedNode;
    return new MentionNode(id, name);
  }

  createDOM() {
    const dom = document.createElement("span");
    dom.className = "mention";
    return dom;
  }

  exportDOM() {
    const wrapper = document.createElement("span");
    wrapper.className = "mention-wrapper";

    // Set the exact HTML as string
    wrapper.innerHTML = `
    <span style="display:inline-flex; align-items:center;">
      <span>
        <img src="https://i.pravatar.cc/100?u=${this.__id}" 
             alt="${this.__name}" 
             class="rounded-full" 
             style="width:20px;height:20px;border-radius:50%;margin-right:4px;" />
      </span>
      <span class="mention text-blue-600 cursor-pointer">${this.__name}</span>
    </span>
    <span class="mention-card">
      <span class="mention-card-content">
        <img src="https://i.pravatar.cc/100?u=${
          this.__id
        }" class="mention-avatar" />
        <span>
          <span class="mention-name">${this.__name}</span>
          <span class="mention-email">${this.__name
            .toLowerCase()
            .replace(" ", ".")}@company.com</span>
        </span>
      </span>
    </span>
  `;

    return { element: wrapper };
  }

  updateDOM() {
    return false;
  }

  // Optional: support pasting HTML
  static importDOM() {
    return {
      span: (domNode) => {
        if (domNode.classList.contains("mention")) {
          const name = domNode.textContent?.replace(/^@/, "") || "";
          return { node: new MentionNode("", name) };
        }
        return null;
      },
    };
  }

  decorate() {
    return <MentionComponent id={this.__id} name={this.__name} />;
  }
}

export function $createMentionNode(id, name) {
  return new MentionNode(id, name);
}
